"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3892],{

/***/ 23892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20.791 4.6c.2-.3.3-.7.1-1.1-.2-.3-.5-.5-.9-.5H4.009c-.4 0-.7.2-.9.6-.2.3-.1.7.1 1l7.793 9.8V18H8.004c-.6 0-1 .4-1 1s.4 1 1 1h7.992c.6 0 .999-.4.999-1s-.4-1-1-1H13v-3.6l7.792-9.8zM9.302 9h5.395L12 12.4 9.302 9zm8.592-4l-1.598 2.1c-.1-.1-.2-.1-.3-.1H8.004c-.1 0-.2 0-.3.1L6.106 5h11.788z"
}), "NightClub"));


/***/ })

}]);